module.exports = __webpack_public_path__ + "cartao_azul.svg?06cd8dd6edcf824ba1dcf19876becbbe";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icones_app/cartao_azul.svg
// module id = 491
// module chunks = 0